/**
 * Confirmation shown before saving an interview scorecard edit that would
 * stop this candidate's stage automation — i.e. the scorecard is being made
 * optional while a downstream automated activity is gated on its submission.
 *
 * Mirrors the assessment drawer's stop-automation confirm so both surfaces
 * warn consistently. Cancelling leaves the edit drawer open and the
 * automation untouched.
 */
import { Modal, Text } from '@kula-ai/components';
import { SCHEDULE_INTERVIEW_COPY } from '../config/copy';

export interface ScorecardStopConfirmDialogProps {
  /** Called when the user confirms — proceeds with the save. */
  onConfirm: () => void;
  /** Called when the user cancels — dialog dismissed, drawer stays open. */
  onCancel: () => void;
  isLoading?: boolean;
}

export const ScorecardStopConfirmDialog = ({
  onConfirm,
  onCancel,
  isLoading = false,
}: ScorecardStopConfirmDialogProps) => {
  const copy = SCHEDULE_INTERVIEW_COPY.editDialogs.stopAutomation;

  return (
    <Modal
      open
      onOpenChange={(open) => {
        if (!open && !isLoading) onCancel();
      }}
      title={copy.title}
      overlayZIndex={1450}
      contentZIndex={1500}
      primaryButton={{
        label: SCHEDULE_INTERVIEW_COPY.footer.saveInterview,
        onClick: onConfirm,
        isLoading,
      }}
      secondaryButton={{
        label: SCHEDULE_INTERVIEW_COPY.footer.cancel,
        onClick: onCancel,
        disabled: isLoading,
      }}
    >
      <Text variant="p">{copy.description}</Text>
    </Modal>
  );
};
